import { Receipt } from "lucide-react";
import { NavigationLinkProps } from "../../providers/Router";
import { FEATURE_TIMESHEETS } from "../../utils/UserAccessControlUtils";
import TimesheetDirectoryPage from "./pages/TimesheetDirectoryPage";
import TimesheetIssuesPage from "./pages/TimesheetIssuesPage";
import FeatureFlags from "../../common/feature-flagging/FeatureFlags";

const TimesheetRouter: NavigationLinkProps[] = [
  {
    id: "f4aeb53b-7cbf-4811-a0ca-28864b5ddaa8",
    title: "Timesheets",
    description: "",
    path: "/timesheets",
    auth: true,
    sidebar: true,
    secondarySidebar: false,
    icon: Receipt,
    component: TimesheetDirectoryPage,
    requiredFeature: FEATURE_TIMESHEETS,
    requiredPermissions: ["ANY"],
    requiredFeatureFlag: FeatureFlags.EMPLOYER_PORTAL_ROSTER_TIMESHEET_VIEW,
  },
  {
    id: "c5966906-0b38-47f9-b92f-c35b5bd3eef1",
    title: "Timesheets",
    description: "",
    path: "/timesheets/:id/errors",
    auth: true,
    sidebar: false,
    secondarySidebar: false,
    component: TimesheetIssuesPage,
    requiredFeature: FEATURE_TIMESHEETS,
    requiredPermissions: ["ANY"],
    requiredFeatureFlag: FeatureFlags.EMPLOYER_PORTAL_ROSTER_TIMESHEET_VIEW,
  },
];

export default TimesheetRouter;
